import React from 'react';

// eslint-disable-next-line react/prop-types
const ColorBar = ({ color }) => <div className="flgshp-color-bar" style={{ backgroundColor: color }} />;

export default ColorBar;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Flagship/components/ColorBar.jsx